import ValueObject from './ValueObject';

export default class InfraComponent extends ValueObject {
  equals(other) {
    if (!(other instanceof InfraComponent)) {
      return false;
    }

    return super.equals(other);
  }

  static fromJSON(json) {
    return new InfraComponent(json);
  }
}
